import { FontsStyle } from "../../assets/font/FontsStyle";

export const getFontStyle = name => {
    return FontStyles[name];
};

export const FontStyles = {
    ...FontsStyle,
};
